import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class DataSettings extends VisualizatorSettings {
  constructor(settings) {
    super(settings);
    const settingsArrayFields = ["sources", "units"];
    for (let i = 0; i < settingsArrayFields.length; i++) {
      this[settingsArrayFields[i]] = [];
    }
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (settingsArrayFields.includes(key)) {
        this[key] = VisualizatorSettings.copySettingsArray(settings[key]);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new DataSettings(this);
  }
}
